import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [text, setText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const fullText = 'Silo Sphere';
  const typingSpeed = 150;
  const cursorBlinkSpeed = 500;

  useEffect(() => {
    let currentIndex = 0;
    const typeInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(typeInterval);
      }
    }, typingSpeed);

    return () => clearInterval(typeInterval);
  }, []);

  return (
    <div className="hero">
      <div className="hero-content">
        <h1 className="hero-title">
          {text}
          <span className={`cursor ${isTyping ? 'blinking' : ''}`}>|</span>
        </h1>
        <p className="hero-subtitle">
          Innovative Software Solutions
        </p>
      </div>
      <div className="matrix-bg"></div>
    </div>
  );
};

export default Hero; 